import { gql } from '@apollo/client';
export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput) {
    createUser(input: $input) {
      id
      email
      fullName
      role {
        id
      }
    }
  }
`;
